import {useContext} from 'react';
import type {TimelineBag} from '@Libraries/timeline/types';
import {timelineContext} from '@Libraries/timeline/types';

export default function useTimelineContext(): TimelineBag {
  const contextValue = useContext(timelineContext);

  if (contextValue === undefined) {
    throw new Error('dnd-timeline: useTimelineContext() must be used within a TimelineContext');
  }

  return contextValue;
}
